import { render } from "./UpdateCar.vue?vue&type=template&id=57d849ca&scoped=true&ts=true"
import script from "./UpdateCar.vue?vue&type=script&lang=ts"
export * from "./UpdateCar.vue?vue&type=script&lang=ts"

import "./UpdateCar.vue?vue&type=style&index=0&id=57d849ca&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d849ca"]])

export default __exports__